// SCNT-3771 bug with duplicate tag and brand

const exceptionTags = [ 'Clean' ]


export default exceptionTags
